export var WAREHOUSE_BOOKING_EVENT = {
    SHOW: "WAREHOUSE_BOOKING_EVENT_SHOW",
};
